import { api } from "@/lib/api";
import { createAppointmentAssignment, type ResourceAssignment } from "@/lib/appointment-assignment";
import { needsAnAssignee } from "@/lib/appointment-reassignment";
import type { uuid } from "@/interfaces";
import { toAppointmentJoin } from "@/repositories/appointment-records";
import { activeOrganization, type AppointmentJoin } from "@/repositories/appointments.repository";

const assignment = createAppointmentAssignment(api.appointments);

export async function assignAppointment(id: uuid, assignee: ResourceAssignment): Promise<AppointmentJoin> {
  return toAppointmentJoin(await assignment.assign(id, assignee, activeOrganization()));
}

export async function unassignAppointment(id: uuid): Promise<AppointmentJoin> {
  return toAppointmentJoin(await assignment.unassign(id, activeOrganization()));
}

export async function stillNeedsAnAssignee(id: uuid): Promise<boolean> {
  return needsAnAssignee(await api.appointments.get(id));
}
